// import { AgentToggleButton, useAgent } from '@agent-panel/index';
import { UserMenu } from '@auth/features/auth';
import { OrganizationSwitch } from '@auth/features/organization-switch';
import { AdminMenu } from '@auth/widgets/admin-menu';
import { PendingCommentsTrigger } from '@itineraries/features/pending-comments-indicator';
import { NotificationDrawerTrigger } from '@notifications/widgets/notification-drawer';
import { SupportDrawerTrigger } from '@support/widgets/support-drawer';
import { TaskDrawerTrigger } from '@task-manager/widgets/task-drawer';
import { ChevronRight, PanelLeft } from 'lucide-react';
import { Button, Text, Tooltip } from '@/shared/ui';
import css from './top-bar.module.scss';

type TopBarProps = {
  breadcrumbs: string[];
  onToggleSidebar?: () => void;
};

export const TopBar = ({ breadcrumbs, onToggleSidebar }: TopBarProps) => {
  // Agent/Co-pilot toggle hidden until further notice.
  // const { open: openAgent } = useAgent();
  return (
    <header className={css.root}>
      <div className={css.left}>
        {onToggleSidebar && (
          <Tooltip content="Toggle Sidebar" position="bottom">
            <Button
              className={css.toggleBtn}
              icon={<PanelLeft className={css.toggleIcon} />}
              onClick={onToggleSidebar}
              size="icon"
              variant="ghost"
            />
          </Tooltip>
        )}
        <div className={css.breadcrumbs}>
          {breadcrumbs.map((crumb, i) => (
            <span className={css.crumbWrap} key={crumb}>
              {i > 0 && <ChevronRight className={css.separator} />}
              <Text as="span" className={css.crumbText}>
                {crumb}
              </Text>
            </span>
          ))}
        </div>
      </div>
      <div className={css.right}>
        <OrganizationSwitch className={css.organizationSwitch} />
        {/* Agent/Co-pilot toggle hidden until further notice.
        <AgentToggleButton
          className={css.headerControl}
          label="Open agent"
          onClick={openAgent}
        />
        */}
        <TaskDrawerTrigger className={css.headerControl} />
        <SupportDrawerTrigger className={css.headerControl} />
        <PendingCommentsTrigger className={css.headerControl} />
        <NotificationDrawerTrigger className={css.headerControl} />
        <AdminMenu />
        <UserMenu className={css.headerControl} />
      </div>
    </header>
  );
};
